import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ParametrosMaestro } from 'src/app/models/common/enumModel';
import { CompaniaModel } from 'src/app/models/compania/CompaniaModel';
import { FilterCompaniaModel } from 'src/app/models/compania/FilterCompaniaModel';
import { IFilterCompaniaModel } from 'src/app/models/interfaces/compania/IFilterCompaniaModel';
import { ISedeModel } from 'src/app/models/interfaces/sedes/ISedeModel';
import { ParametroModel } from 'src/app/models/parametros/ParametroModel';
import { SedeModel } from 'src/app/models/sede/SedeModel';
import { AlertDialogService } from 'src/app/services/alert-dialog/alert-dialog.service';
import { CompaniaService } from 'src/app/services/compania/compania.service';
import { ConfirmDialogService } from 'src/app/services/confirm-dialog/confirm-dialog.service';
import { ParametroService } from 'src/app/services/parametros/parametro.service';
import { SedeService } from 'src/app/services/sede/sede.service';

@Component({
  selector: 'app-configuracion-sede-editar',
  templateUrl: './configuracion-sede-editar.component.html',
  styleUrls: ['./configuracion-sede-editar.component.css']
})
export class ConfiguracionSedeEditarComponent implements OnInit {
  id: number = 0;
  model: ISedeModel = new SedeModel();
  listaEstados: ParametroModel[] = new Array<ParametroModel>();
  listaCompanias: CompaniaModel[] = new Array<CompaniaModel>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private companiaService: CompaniaService,
    private servideSede: SedeService,
    private serviceParametros: ParametroService,
    private confirmDialogService: ConfirmDialogService,
    private alertDialogService: AlertDialogService,
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    let filterCompania: IFilterCompaniaModel = new FilterCompaniaModel();
    this.companiaService
      .getAllList(filterCompania)
      .subscribe((data: CompaniaModel[]) => {
        this.listaCompanias = data;
      });

    this.serviceParametros.getDetalles(ParametrosMaestro.ESTADO_CONFIG_TIPO_VISITA).subscribe((data) => {
      this.listaEstados = data.items;
    });

    this.servideSede.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  onSubmit(form: NgForm) {
    if (!form.invalid) {   
      this.confirmDialogService.open('¿Deseas guardar los cambios?'); //options
      this.confirmDialogService.confirmed().subscribe((confirmed) => {
        if (confirmed) {
          this.servideSede.update(this.model).subscribe((data) => {
            this.alertDialogService.open("La sede fue actualizada");
            this.router.navigate(['/configuracion', 'sedes']);  
          });
        }
      });
    }
  }
}
